var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#4285f4",
    d: "M24.016 13.118c0-.815-.066-1.636-.207-2.438H12.49v4.62h6.482a5.55 5.55 0 0 1-2.399 3.647v2.999h3.867c2.271-2.09 3.576-5.177 3.576-8.828"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#34a853",
    d: "M12.49 24.843c3.237 0 5.966-1.063 7.955-2.897l-3.867-2.999c-1.076.732-2.465 1.147-4.083 1.147-3.131 0-5.786-2.112-6.738-4.952h-3.99v3.091a12 12 0 0 0 10.723 6.61"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fbbc04",
    d: "M5.753 15.142a7.2 7.2 0 0 1 0-4.595v-3.09H1.767a12.01 12.01 0 0 0 0 10.776z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ea4335",
    d: "M12.49 5.591a6.52 6.52 0 0 1 4.603 1.8l3.427-3.427A11.53 11.53 0 0 0 12.49.843 12 12 0 0 0 1.767 7.457l3.986 3.09C6.7 7.704 9.359 5.591 12.49 5.591"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.25.842h24v24h-24z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleIcon);
export default __webpack_public_path__ + "static/media/googleIcon.0f4173b89c983b2275be2d9e58225c39.svg";
export { ForwardRef as ReactComponent };